import { render, staticRenderFns } from "./GoodsPackageEdit.vue?vue&type=template&id=22ac307b&"
import script from "./GoodsPackageEdit.vue?vue&type=script&lang=js&"
export * from "./GoodsPackageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports